import { GridCellProps } from '@progress/kendo-react-grid';
import { FC, useMemo } from 'react';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';

const GlCodeTaxableAmount: FC<GridCellProps> = (props) => {
  const { dataItem } = props;
  const { displayValue } = useGridCellDisplayValue(props);
  const isTotals = useMemo(() => dataItem.rowId === 'noExpand', [dataItem]);

  return (
    <GridCellBase {...props} title={displayValue}>
      <div className={`${isTotals && 'font-bold  flex justify-end items-center'} text-right`}>
        {displayValue}
      </div>
    </GridCellBase>
  );
};

export default GlCodeTaxableAmount;
